
export { getCookieAuthorizationToken } from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/auth/services/token-service.ts"
export { getCookieProfileUser } from "/builds/t2_e_sw-P/0/dd3tech/wiggot/wiggot-web/packages/auth/services/token-service.ts"